<div class="add-colleague-dialog crm-dialog">
  <h2 mat-dialog-title>
    <mat-icon>{{ data.editing ? 'edit' : 'person_add' }}</mat-icon>
    {{ data.editing ? 'Kolléga szerkesztése' : 'Új kolléga hozzáadása' }}
  </h2>
  
  <mat-dialog-content>
    <form class="colleague-form">
      <!-- Teljes név -->
      <mat-form-field class="full-width">
        <mat-label>Teljes név</mat-label>
        <input matInput 
               [(ngModel)]="colleagueData.name" 
               name="name"
               autocomplete="name"
               placeholder="Példa: Nagy János"
               required
               (input)="onFieldInput()">
        <mat-icon matSuffix>person</mat-icon>
      </mat-form-field>

      <!-- Felhasználónév -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Felhasználónév</mat-label>
        <input matInput 
               [(ngModel)]="colleagueData.username"
               name="username"
               autocomplete="username"
               required
               placeholder="felhasznalonev"
               (input)="onFieldInput()">
        <mat-icon matSuffix>alternate_email</mat-icon>
      </mat-form-field>

      <!-- Email cím -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email cím</mat-label>
        <input matInput 
               type="email"
               [(ngModel)]="colleagueData.email"
               name="email"
               autocomplete="email"
               required
               placeholder="email@ceg.hu"
               (input)="onEmailInput()"
               (keydown)="blockAccentedCharsInEmail($event)"
               (paste)="onEmailPaste()">
        <mat-icon matSuffix>email</mat-icon>
        @if (emailError) {
          <mat-hint class="phone-error">
            {{ emailError }}
          </mat-hint>
        }
      </mat-form-field>

      <!-- Telefonszám -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Telefonszám</mat-label>
        <input matInput 
               type="tel"
               [(ngModel)]="colleagueData.phone"
               name="phone"
               autocomplete="tel"
               placeholder="+36 30 123 4567"
               maxlength="16"
               (input)="onPhoneNumberInput()"
               (keydown)="onPhoneKeyDown($event)"
               [class.phone-valid]="isPhoneNumberValid === true"
               [class.phone-invalid]="isPhoneNumberValid === false"
               #phoneField>
        <mat-icon matSuffix>phone</mat-icon>
        <!-- <mat-hint>Érvényes formátum: +36 30 999 9999</mat-hint> -->
        @if (isPhoneNumberValid === false) {
          <mat-hint class="phone-error">
            Érvényes magyar mobil szám formátum: +36 30 999 9999
          </mat-hint>
        }
      </mat-form-field>

      <!-- Munkakörök (checkbox lista) -->
      <div class="job-titles-section">
        <label class="job-titles-label">Munkakör(ök) *</label>
        <div class="job-titles-checkboxes">
          @for (jt of data.jobTitles; track jt) {
            <mat-checkbox
              [checked]="isJobSelected(jt)"
              (change)="onJobTitleToggle(jt, $event.checked)">
              {{ jt }}
            </mat-checkbox>
          }
        </div>
        @if (selectedJobs.length === 0) {
          <mat-hint class="phone-error">Legalább egy munkakör kiválasztása kötelező</mat-hint>
        }
      </div>

      <mat-divider></mat-divider>

      <!-- Aktív státusz -->
      <div class="checkbox-field">
        <mat-checkbox [(ngModel)]="colleagueData.is_active" name="is_active">
          Aktív felhasználó
        </mat-checkbox>
      </div>

      <!-- Hibaüzenet -->
      @if (errorMessage) {
        <div class="error-message">
          <mat-icon>error</mat-icon>
          {{ errorMessage }}
        </div>
      }

      <!-- Információs üzenet új kolléga esetén -->
      @if (!data.editing) {
        <div class="info-message">
          <mat-icon class="overflow-hidden">info</mat-icon>
          Az új kolléga alapértelmezett jelszóval kerül létrehozásra. A jelszót első bejelentkezéskor kell megváltoztatnia.
        </div>
      }
    </form>
  </mat-dialog-content>
  
  <mat-dialog-actions style="justify-content: space-between">
    @if (data.editing) {
      <button mat-stroked-button
              color="warn"
              (click)="onResetPassword()"
              [disabled]="isLoading || isResettingPassword">
        <mat-icon>lock_reset</mat-icon>
        {{ isResettingPassword ? 'Visszaállítás...' : 'Jelszó visszaállítás' }}
      </button>
    } @else {
      <span></span>
    }
    <div>
      <button mat-button (click)="onCancel()" [disabled]="isLoading">
        Mégse
      </button>
      <button mat-raised-button 
              color="primary" 
              (click)="onSave()" 
              [disabled]="!formValid || isLoading">
        @if (isLoading) {
          <mat-spinner diameter="20"></mat-spinner>
        }
        @if (!isLoading) {
          <mat-icon>{{ data.editing ? 'save' : 'person_add' }}</mat-icon>
        }
        {{ isLoading ? (data.editing ? 'Mentés...' : 'Létrehozás...') : (data.editing ? 'Mentés' : 'Kolléga hozzáadása') }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
